import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.
const PrivacyView = () => import(/* webpackChunkName: "privacy-page" */ './views/PrivacyView.vue');

export default new Router({
  routes: [
    {
      path: '/',
      name: 'privacy-home',
      component: PrivacyView,
    },
    {
      path: '*',
      redirect: { name: 'privacy-home' },
    },
  ],
});
